import React, { useEffect, useState } from "react";
import "./allPrice.style.scss";
import worldMap from "../pic/world-map.svg";
import LivePrice from "../livePrice/livePrice";
import { SERVER, SITEURL } from "../../api";
import LivePriceSkeleton from "../livePrice/livePrice.skeleton";
import axios from "axios";

export default function AllPricePage(props) {
    const [livePrices, setLivePrices] = useState(null)

    function getData() {
        axios.get(SERVER + "/Market/PriceInfos", "accept: text/plain").then(res => {
            setLivePrices(res.data.data);
        });
        setTimeout(() => {
            getData()
        }, 30000)
    }

    useEffect(() => {
        getData()
    }, [])
    return (
        <div className="tmex-static-page-data-all-price">
            <div className='content'>
                <h1 className='title'>قیمت ارزها</h1>
                <div className='my-container'>
                    {livePrices ? livePrices.map((item, index) => (
                        <LivePrice id={item.symbol}
                            name={item.name}
                            price={item.weeklyPriceLog[item.weeklyPriceLog.length - 1]}
                            image={SITEURL + `${item.icon}`}
                            changeAmout={item.changeOf24HourAmount}
                            changePercent={item.changeOf24HourPercent}
                            data={item.weeklyPriceLog}
                        />
                    )) : (<React.Fragment><LivePriceSkeleton />
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                        <LivePriceSkeleton />
                    </React.Fragment>)}


                </div>
            </div>

        </div>
    );
}
